import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  noteResourceObject: {
    noteResource: null,
    noteResourceSetBy: null,
  },
};

const NoteContext = createContext(defaultState);

const NoteContextProvider = ({ children }) => {
  const [noteResourceObject, setNoteResourceObject] = useState(defaultState.noteResourceObject);

  return <NoteContext.Provider value={{ noteResourceObject, setNoteResourceObject }}>{children}</NoteContext.Provider>;
};

// Deprecated: do not use context or hook for any component other than the Add Note Floating Action Button
export const useNoteContext = () => {
  const context = useContext(NoteContext);

  if (!context) throw new Error('useMeetingContext must be called from MeetingContext.Provider');

  return context;
};

NoteContextProvider.propTypes = {
  children: PropTypes.any.isRequired,
};

export default NoteContextProvider;
